import React from "react";
import { NavLink } from "react-router-dom";

function NavBar() {
  return (
    <nav className="navigation">
      <NavLink to="/"> Home</NavLink>
      <NavLink to="/characters"> Characters</NavLink>
      <NavLink to="/newCharacter"> Add New Character</NavLink>
    </nav>
  );
}

export default NavBar;

